import { render, staticRenderFns } from "./Projectbom.vue?vue&type=template&id=754775f6&scoped=true&"
import script from "./Projectbom.vue?vue&type=script&lang=js&"
export * from "./Projectbom.vue?vue&type=script&lang=js&"
import style0 from "./Projectbom.vue?vue&type=style&index=0&id=754775f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754775f6",
  null
  
)

export default component.exports